export default __webpack_public_path__ + "static/media/Cubic_11_1.013_R.a58a517e.ttf";